var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BDStatusPill,{staticClass:"status-pill",attrs:{"color":_setup.STATUS_COLORS[_vm.status],"label":_setup.clientInviteStateLabels[_vm.status]}},[(_vm.status === _setup.ClientInviteState.DUE_A_REMINDER)?_c('InfoTooltip',{staticClass:"reminder-tooltip"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }